import { Box, BoxOwnProps, Icons } from "@sembark-travel/ui-base"

export function Thumbnail({
	imageUrl,
	size = "16",
	fallbackIcon = <Icons.Bed size="6" color="primary" />,
}: {
	imageUrl?: string | null
	size?: BoxOwnProps["size"]
	fallbackIcon?: React.ReactNode
}) {
	if (imageUrl) {
		return (
			<Box
				as="img"
				src={imageUrl}
				alt=""
				loading="lazy"
				size={size}
				borderWidth="1"
				rounded="md"
				flexShrink="0"
				style={{ objectFit: "cover" }}
			/>
		)
	}
	return (
		<Box
			display="flex"
			size={size}
			flexShrink="0"
			alignItems="center"
			justifyContent="center"
			bgColor="primary"
			borderWidth="1"
			borderColor="primary"
			rounded="md"
		>
			{fallbackIcon}
		</Box>
	)
}
